<div class="overlay"
     *ngIf="isLoading">
     <h1 class="heading"
          [innerHtml]="tag | translator: Selecttranslator">
     </h1>
     <img [alt]="tag | translator: Selecttranslator" />
</div>